import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { FormattedMessage, injectIntl } from 'react-intl';

const Footer = ({ intl }) => {
    return (
        <div>
            <div className="container-fluid text-center footer">
                <div className="row">
                    <div className="col-lg-12">
                        <h4 className="text-center"><FormattedMessage id="footer.copyright" /></h4>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(Footer);



// WEBPACK FOOTER //
// app/containers/Footer.jsx